import styles from './ComingSoon.module.css';

const CONTACT_EMAIL = 'skcsolut@skcsolution.in';

export default function ComingSoon() {
  const year = new Date().getFullYear();

  return (
    <div className={styles.page}>
      <div className={styles.glow} aria-hidden="true" />
      <main className={styles.card}>
        <p className={styles.badge}>Coming soon</p>
        <h1 className={styles.title}>SKC Solution</h1>
        <p className={styles.lead}>
          We are building a new home for our business software and digital
          solutions. Check back shortly.
        </p>
        <div className={styles.divider} />
        <p className={styles.contact}>
          Questions?{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
      </main>
      <footer className={styles.footer}>
        &copy; {year} SKC Solution. All rights reserved.
      </footer>
    </div>
  );
}
